var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.tableLoading,"row-key":_vm.rowKey,"highlight-row":""},on:{"on-select-cancel":_vm.fnCancel,"on-select-all-cancel":_vm.fnCancelAll,"on-select":_vm.fnSelect,"on-select-all":_vm.fnSelectAll},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var row = ref.row;
return [_vm._t("more-actions",null,{"row":row})]}}],null,true)})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae39a0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/checkboxTable/index.vue
// module id = null
// module chunks = 